var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container section-scc-portal"},[_c('b-alert',{attrs:{"show":_vm.showMessage,"variant":_vm.typeColor,"dismissible":""},on:{"dismissed":_vm.closeMessageBox}},[_c('div',{staticClass:"span-login-page"},[_vm._v(" "+_vm._s(_vm.textMessage)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }